/**
 * @license
 * Copyright 2026 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 *
 * g3-prettier-ignore-file
 */

/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as interactions from "../interactions/index.js";
import { GoogleGenAiError } from "./google-gen-ai-error.js";

/**
 * Error cancelling interaction
 */
export type CancelInteractionByIdServerErrorData = {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;
};

/**
 * Error cancelling interaction
 */
export class CancelInteractionByIdServerError extends GoogleGenAiError {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;

  /** The original data that was passed to this error instance. */
  data$: CancelInteractionByIdServerErrorData;

  constructor(
    err: CancelInteractionByIdServerErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.error?.message
      || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.error = err.error;

    this.name = "CancelInteractionByIdServerError";
  }
}

/**
 * Error cancelling interaction
 */
export type CancelInteractionByIdClientErrorData = {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;
};

/**
 * Error cancelling interaction
 */
export class CancelInteractionByIdClientError extends GoogleGenAiError {
  /**
   * Error message from an interaction.
   */
  error: interactions.ErrorT;

  /** The original data that was passed to this error instance. */
  data$: CancelInteractionByIdClientErrorData;

  constructor(
    err: CancelInteractionByIdClientErrorData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.error?.message
      || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.error = err.error;

    this.name = "CancelInteractionByIdClientError";
  }
}
